/* unplugin-vue-components disabled */import script from "./AssetRepository.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetRepository.vue?vue&type=script&setup=true&lang=js"

import "./AssetRepository.vue?vue&type=style&index=0&id=2befe971&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2befe971"]])

export default __exports__